import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { get } from 'lodash';

import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';
import Table from '../../modules/table';
import { getDocuments } from '../../store/actions/documents';
import { RootState } from '../../types';
import { DOCUMENT_TYPE } from '../../types';
import { DOCUMENTS_SEARCH_FILTERS, SORT_DIRECTION } from '../../types';

import COLUMNS from './columns';
import Filters from './filters';
import RowComponent from './row-component';

import './index.scss';

const BASE_PAGE_SIZE = 10;

const Documents: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const documents = useSelector(
    (state: RootState) => state.documents.data.documents
  );
  const pagination = useSelector(
    (state: RootState) => state.documents.data.pagination
  );
  const loading = useSelector(
    (state: RootState) => state.documents.loading.documents
  );
  let initFilters = localStorage.getItem('documentsFilter');
  const [filters, setFilters] = useState<DOCUMENTS_SEARCH_FILTERS>(
    initFilters
      ? {
          ...JSON.parse(initFilters),
          page: {
            number: 0,
            size: BASE_PAGE_SIZE,
          },
        }
      : {
          page: {
            number: 0,
            size: BASE_PAGE_SIZE,
          },
        }
  );

  useEffect(() => {
    dispatch(getDocuments({ filters, concat: true }));
    const { page, search, ...omit } = filters;
    localStorage.setItem('documentsFilter', JSON.stringify(omit));
  }, [filters]);

  const handleChangeFilters = (data: Record<string, any>) =>
    setFilters({
      ...filters,
      ...data,
      page: {
        size: BASE_PAGE_SIZE,
        number: 0,
      },
    });

  const onLoadMore = () =>
    setFilters({
      ...filters,
      page: {
        size: BASE_PAGE_SIZE,
        number: get(filters, 'page.number', 0) + 1,
      },
    });

  return (
    <AppPageMain>
      <div className="container documents">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                {
                  link: '',
                  title: 'Документы',
                },
              ]}
              iconType="documents"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <div className="documents__container">
              <Filters onChange={handleChangeFilters} filters={filters} />
              <Table
                loading={loading}
                columns={COLUMNS(
                  (direction: SORT_DIRECTION) =>
                    handleChangeFilters({
                      period: { ...filters.period, direction },
                    }),
                  filters.period?.direction || 'ASC'
                )}
                RowComponent={RowComponent}
                onRowClick={({ id, type }: { id: string; type: DOCUMENT_TYPE }) =>
                  history.push(`documents/${id}`, { id, type })
                }
                data={documents}
                onLoadMore={onLoadMore}
                footer={!pagination.isLast}
                onLoadMoreText="Загрузить еще документы"
              />
            </div>
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default Documents;
